import responsiveConfig from './testResponsiveConfig'

export default {
    ...responsiveConfig,
    supportsUsingPresetVariants: true,
    modulesList: responsiveConfig.modulesList.concat(['appStudioPublicAPI'])
}
